import React from 'react';
import {useFormContext} from "react-hook-form";
import Grid from "@mui/material/Grid";
import {CustomAutoComplete} from "../../../../widgets/inputs/CustomAutoComplete";
import {medici} from "../../../../../utils/arrays/Medici";
import {Divider} from "@mui/material";
import { Alert, AlertTitle } from '@mui/material';
import CustomText from "../../../../widgets/inputs/CustomText";
import {
	bigNoteRegisterNotRequired,
	cognomeRegisterNone,
	emailRegisterNone,
	nomeRegisterNone,
	phoneRegisterPrivate
} from "../../../../../utils/RegisterUtils";
import {CELLULARE_MEDICO, COGNOME_MEDICO, EMAIL_MEDICO, FISSO_MEDICO, NOME_MEDICO} from "../../../../../strings/IT";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";

export const MedicoGrid = ({note = true, isCit = false}) => {
	const {errors, control, register} = useFormContext();
	
	return (
		<React.Fragment>
			
			{!isCit && <React.Fragment>
				<Grid item xs={12}>
					<CustomAutoComplete
						label={"Cerca e seleziona un medico"}
						control={control}
						options={medici}
						multiple={false}
						rules={{required: false}}
						name={"medico"}
						error={errors["medico"]}
					/>
				</Grid>
				<Grid item xs={12}>
					<Divider/>
				</Grid>
				<Grid item xs={12}>
					<Alert severity="info" style={{borderRadius: 24, margin: 4}}>
						<AlertTitle><b>Info</b></AlertTitle>
						Compila i punti successivi <strong>SOLO</strong> nel caso in cui il medico non sia presente
						nell'elenco.<br/>
					</Alert>
				</Grid>
			</React.Fragment>}
			
			{isCit && <Grid item xs={12}>
				<Alert severity="info" style={{borderRadius: 24, margin: 4}}>
					<AlertTitle><b>Info</b></AlertTitle>
					Nel caso tu non conosca tutti i dati del tuo medico puoi indicare solamente nome e cognome.
				</Alert>
			</Grid>}
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={cognomeRegisterNone}
					name={"cognomeMedico"}
					label={COGNOME_MEDICO}
					autoFocus={false}
					error={errors["cognomeMedico"]}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={nomeRegisterNone}
					name={"nomeMedico"}
					label={NOME_MEDICO}
					autoFocus={false}
					error={errors["nomeMedico"]}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={phoneRegisterPrivate}
					name={"cellMedico"}
					label={CELLULARE_MEDICO}
					autoFocus={false}
					error={errors["cellMedico"]}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={phoneRegisterPrivate}
					name={"fissoMedico"}
					label={FISSO_MEDICO}
					autoFocus={false}
					error={errors["fissoMedico"]}
				/>
			</Grid>
			<Grid item xs={12}>
				<CustomText
					control={control}
					rules={emailRegisterNone}
					name={"emailMedico"}
					label={EMAIL_MEDICO}
					autoFocus={false}
					error={errors["emailMedico"]}
				/>
			</Grid>
			{note && <Grid item xs={12}>
				<CustomMultiText
					inputRef={register(bigNoteRegisterNotRequired)}
					name={"note2"}
					label={"Note aggiuntive"}
					autoFocus={false}
					error={errors["note2"]}
				/>
			</Grid>}
		</React.Fragment>
	);
};
